import React from 'react';
//import Nav from './nav';
import NavTwo from './nav2';
import Sidebar from './Sidebar';
import Overview from './Overview';
import Selection from './selections';
import ClientPlantCode from './ClientPlantCode'
function ClientPlant(){

    return (
       
        <>
            <NavTwo />
            <div className='wrap'>
            
          
            <div className='contentWrap' style={{width: "100%"}}>
                <div className='OverviewContainer' style={{padding: "150px", paddingTop:"50px"}}>
                <ClientPlantCode /> 
             
                </div>
            </div>

            </div>
        </>
    )
}

export default ClientPlant;